import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface TeaserProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

export const Teaser: React.FC<TeaserProps> = ({
  width = 1000,
  height = 800,
  fill = "currentColor",
  className,
}) => {
  return (
    <Card className="mx-auto max-w-[800px] w-full">
      <CardContent className="flex flex-col items-center p-6">
        <div className=" max-w-[300px] mx-auto my-[100px]">
          <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="xMidYMid meet"
            className={className}
            style={{ maxWidth: "100%", height: "auto", width: "100%" }}
          >
            <g
              transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
              fill={fill}
              stroke="none"
            >
              <path
                d="M9060 9270 c-140 -49 -601 -208 -1025 -353 -423 -146 -783 -271 -799
          -278 -17 -8 -116 -117 -234 -259 -239 -284 -491 -583 -971 -1149 -189 -224
          -353 -419 -365 -434 l-22 -28 -295 167 c-1009 571 -996 564 -1038 564 -22 0
          -52 -5 -66 -12 -25 -11 -360 -448 -1351 -1761 l-341 -452 -349 -57 c-1011
          -168 -1360 -230 -1390 -249 -33 -20 -64 -72 -64 -108 0 -68 63 -131 130 -131
          19 0 150 20 290 44 140 25 460 79 710 121 781 131 788 132 812 151 13 9 91
          108 174 218 84 111 361 478 616 816 255 338 549 728 653 865 103 138 191 254
          196 258 4 5 17 2 30 -6 42 -27 1189 -677 1240 -702 57 -30 83 -31 126 -7 41
          22 536 609 527 624 -4 6 -3 8 4 4 6 -3 33 20 60 51 140 164 653 770 840 994
          l214 255 146 48 c176 58 1438 487 1707 580 208 72 247 97 260 170 14 73 -55
          147 -135 145 -19 0 -150 -40 -290 -89z m307 74 c-3 -3 -12 -4 -19 -1 -8 3 -5
          6 6 6 11 1 17 -2 13 -5z"
              />
              <path
                d="M8500 5180 l0 -2730 495 0 495 0 0 2730 0 2730 -495 0 -495 0 0
          -2730z"
              />
              <path
                d="M6940 4895 l0 -2445 495 0 495 0 0 2445 0 2445 -495 0 -495 0 0
          -2445z m387 2429 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m540
          0 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
              />
              <path
                d="M3810 4130 l0 -1680 485 0 485 0 0 1680 0 1680 -485 0 -485 0 0
          -1680z m17 1498 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
              />
              <path
                d="M5380 3810 l0 -1360 488 0 487 0 0 1360 0 1360 -487 0 -488 0 0
          -1360z m17 1138 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -680
          c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -1110 c-3 -7 -5 -2
          -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m0 -550 c-3 -8 -6 -5 -6 6 -1 11 2 17
          5 13 3 -3 4 -12 1 -19z"
              />
              <path d="M2260 3435 l0 -985 485 0 485 0 0 985 0 985 -485 0 -485 0 0 -985z" />
              <path
                d="M750 3295 l0 -845 480 0 480 0 0 845 0 845 -480 0 -480 0 0 -845z
          m947 -62 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z"
              />
            </g>
          </svg>
        </div>
        <div className="block text-center mt-6 text-muted-foreground">
          <p>Looks like we don't have enough data for this chart yet.</p>{" "}
          <p>Add more data to unlock it.</p>
        </div>
      </CardContent>
    </Card>
  );
};
